const TaskStatus = 
{
    Seen : 1,
    Selected : 2,
    Skipped : 3,
    HasError : 4,
    Incompatible : 5
}
;

export default TaskStatus;